import BulkAccountVerificationHeader from './BulkAccountVerificationHeader';
import BulkAccountVerificationTable from './BulkAccountVerificationTable';
import React, { useState } from 'react';

import './bulkpaymentlink.scss';

const BulkAccountVerification= () => {
    const [pageSize, setPageSize] = useState(10);
    return (
        <div className="bulk-payment-link-wrapper">
            <BulkAccountVerificationHeader 
                pageSize = {pageSize}  />
            <BulkAccountVerificationTable
                pageSize = {pageSize}
                setPageSize = {setPageSize}
            />
        </div>
    );
};

export default BulkAccountVerification;
